
/* @ngInject */
export default class PipelineSummaryService {
    constructor($http, UserData, HPConfig) {
        this.$http = $http;
        this.UserData = UserData;
        this.HPConfig = HPConfig;
    }
    getSummary(contractorId) {
        const conf = {};

        if (contractorId !== undefined) {
            conf.ContractorLocationId = contractorId;
        }

        return this.$http({
            url: `${this.HPConfig.heroProApi}Contractor/GetPipelineSummaryHP`,
            method: 'GET',
            params: conf,
            cache: true,
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/pipelineSummary/pipelineSummary.service.js